import { RootState } from "../rootReducer";
import { assistantPageCodeEnum } from "../../features/AssistantPages/constantTypes";

export const assistantPages = (state: RootState) =>
  state.AssistantPagesReducer.assistantPages;

export const isLoading = (state: RootState) =>
  state.AssistantPagesReducer.isLoading;

export const assistantPage = (state: RootState) =>
  state.AssistantPagesReducer.assistantPage;

export const isSuccessOpen = (state: RootState) =>
  state.AssistantPagesReducer.isSuccessOpen;

export const isChatKitAvailable =
  (code: assistantPageCodeEnum | null) => (state: RootState) =>
    code ? state.AssistantPagesReducer.isChatKitAvailable?.[code] : null;
